import { render, staticRenderFns } from "./CytomineProperties.vue?vue&type=template&id=e81baab0&scoped=true"
import script from "./CytomineProperties.vue?vue&type=script&lang=js"
export * from "./CytomineProperties.vue?vue&type=script&lang=js"
import style0 from "./CytomineProperties.vue?vue&type=style&index=0&id=e81baab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81baab0",
  null
  
)

export default component.exports